<template>
  <ul
    v-if="isPc"
    v-infinite-scroll="loadPotential"
    class="my-potential-container"
    :infinite-scroll-disabled="disabledLoadDate"
  >
    <li v-for="(item, index) in potentialList" class="potential-item" :key="index">
      <PotentialInfo isPc :potentialData="item"/>
    </li>
    <li v-if="potentialList.length < 1" class="tips">
      <p>{{ $t('personal.referrals.leads.message.leadNoData') }}</p>
    </li>
  </ul>
  <AnimationCardList
    v-else
    v-infinite-scroll="loadPotential"
    class="my-potential-container"
    dataKey="potential_id"
    empty-tip-i18n-key="personal.referrals.leads.message.leadNoData"
    :infinite-scroll-disabled="disabledLoadDate"
    :data="potentialList"
    :action-options="actionOptions"
    @action="onAction"
  >
    <template #default="{data}">
      <PotentialInfo :potentialData="data"/>
    </template>
  </AnimationCardList>
</template>

<script>
import { mapActions } from 'vuex'
import AnimationCardList, { ACTION_TYPE } from './components/animationCardList.vue'
import PotentialInfo from './components/potentialInfo.vue'
import { deviceType } from '@/utils/common'

export default {
  props: {

  },
  components: {
    AnimationCardList,
    PotentialInfo
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.leads',
      potentialList: [],
      disabledLoadDate: false,
      pageInfo: {
        pageSize: 20,
        currentPage: 1,
        total: 1
      }
    }
  },
  computed: {
    isPc () {
      return deviceType.isPc
    },
    actionOptions () {
      return {
        isShow: this.isShowAction,
        iconClass: this.getActionIconClass,
        tip: this.getActionTip,
        startColor: this.getActionStartColor,
        endColor: this.getActionEndColor,
        startFontSize: this.getActionStartFontSize,
        endFontSize: this.getActionEndFontSize
      }
    }
  },
  created () {

  },
  methods: {
    ...mapActions('personal', ['getMyPotentialCandidate', 'updateMyPotentialCandidateAttitude']),
    ...mapActions('referral', ['']),
    isShowAction (actionType, dataItem) {
      return true
    },
    getActionIconClass (actionType, dataItem) {
      if (ACTION_TYPE.RIGHT === actionType) {
        return 'iconfont iconHide hidden-icon'
      } else if (dataItem.is_top) {
        return 'iconfont icona-RemoveTop cancel-icon'
      } else {
        return 'iconfont icona-PinTop top-icon'
      }
    },
    getActionTip (actionType, dataItem) {
      const i18nKey = ACTION_TYPE.RIGHT === actionType ? 'hide' : dataItem.is_top ? 'removeTop' : 'pinTop'
      return this.$t(`${this.i18nPrefix}.btn.moveAction.${i18nKey}`)
    },
    getActionStartColor (actionType, dataItem) {
      return (dataItem.is_top || ACTION_TYPE.RIGHT === actionType) ? '#ef524b' : '#15aa66'
    },
    getActionEndColor (actionType, dataItem) {
      return (dataItem.is_top || ACTION_TYPE.RIGHT === actionType) ? '#ffffff' : '#ffffff'
    },
    getActionStartFontSize (actionType, dataItem) {
      return 12
    },
    getActionEndFontSize (actionType, dataItem) {
      return 16
    },
    async initData () {
      this.getPotentialCandidateData(this.page)
    },
    async getPotentialCandidateData (page) {
      this.$eventBus.$emit('showLoading', true)
      this.disabledLoadDate = true
      try {
        const params = {
          page: this.pageInfo.currentPage,
          page_size: this.pageInfo.pageSize
        }
        if (!this.isPc) {
          params.company_id = this.$route.query.company_id
        }
        const resp = await this.getMyPotentialCandidate(params)
        if (resp) {
          this.pageInfo.total = resp.total_pages
          this.pageInfo.currentPage += 1
          if (this.pageInfo.total > 0 && this.pageInfo.currentPage < this.pageInfo.total) {
            this.disabledLoadDate = false
          }
          this.potentialList = this.potentialList.concat(resp.results)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    loadPotential () {
      this.getPotentialCandidateData(this.pageInfo.currentPage)
    },
    async onAction ({ actionType, dataItem, onFinished }) {
      this.$eventBus.$emit('showLoading', true)
      let resp = null
      this.disabledLoadDate = true
      try {
        this.pageInfo.currentPage = 1
        const params = {
          data_type: 'leads',
          page: this.pageInfo.currentPage,
          page_size: this.pageInfo.pageSize,
          potential_id: dataItem.potential_id,
          company_id: this.$route.query.company_id
        }
        if (actionType === ACTION_TYPE.LEFT && dataItem.is_top) {
          params.action = '4'
        } else if (actionType === ACTION_TYPE.LEFT && !dataItem.is_top) {
          params.action = '2'
        } else {
          params.action = '1'
        }
        resp = await this.updateMyPotentialCandidateAttitude(params)
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
      if (resp) {
        this.pageInfo.total = resp.total_pages
        if (this.pageInfo.total > 0 && this.pageInfo.currentPage < this.pageInfo.total) {
          this.disabledLoadDate = false
        }
        this.potentialList = resp.results
        await this.$nextTick()
        onFinished(actionType === ACTION_TYPE.RIGHT)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.my-potential-container {
  &.animation-card-list-container {
    ::v-deep {
      .card-action {
        .action-icon {
          .iconfont {
            font-size: inherit;
            color: #ffffff;
          }
        }

        .action-tip {
          color: #ffffff;
        }
      }
    }
  }
}
.page-pc {
  .my-potential-container {
    padding-bottom: 20px;

    .tips {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
